import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser'
import { Content } from '@monorepo/golab-generated'

export abstract class FileShowingComponent {
  url = ''
  safeResourceUrl: SafeResourceUrl = ''
  fileName: string = ''

  protected constructor(private readonly sanitizer: DomSanitizer) {}

  protected setUrl(content: Content): void {
    const url = content.url ?? ''
    this.fileName = content.fileName ?? ''
    const urlWithFileName = this.addFileNameToUrl(url, this.fileName)
    this.url = this.updateUrl(urlWithFileName)
    this.safeResourceUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.url)
  }

  protected updateUrl(url: string): string {
    return url
  }

  protected splitFileName(name: string): [string, string] {
    const parts = name.split('.')
    if (parts.length < 2) {
      return [name, '']
    }
    return [parts.slice(0, parts.length - 1).join('.'), parts[parts.length - 1]]
  }

  private addFileNameToUrl(url: string, fileName: string): string {
    if (!fileName) {
      return url
    }
    const [urlName, urlExtension] = this.splitFileName(url)
    if (!urlExtension) {
      return `${url}/${fileName}`
    }
    const [nameOfFile] = this.splitFileName(fileName)
    return `${urlName}/${nameOfFile}.${urlExtension}`
  }
}
